"use strict";

angular.module('PatientApp').directive('securecodeInput', function () {
  var _MAX_FORMATTED_LENGTH = 11,
      _getFormattedString = function _getFormattedString(inputStr) {
    var noFormatting = inputStr.split('-').join(''),
        i = 0,
        curChar = '',
        output = '';

    while (i < noFormatting.length) {
      curChar = noFormatting[i];

      if (/[A-Za-z0-9]/.test(curChar)) {
        output += curChar.toUpperCase();
      }

      i++;

      if (output.length === 3 || output.length === 7) {
        output += '-';
      }
    }

    return output.slice(0, _MAX_FORMATTED_LENGTH);
  },
      _lastVal = '';

  return {
    require: 'ngModel',
    link: function link(scope, el, attrs, ngModel) {
      var runValidators = function runValidators(value) {
        ngModel.$setValidity('allNumericSCode', !/[0-9]{3}-[0-9]{3}-[0-9]{3}/.test(value));
      }; // don't allow more than the formatted length


      el.attr('maxlength', _MAX_FORMATTED_LENGTH); // this handles key presses, ups and downs, and pastes
      // this used to be keyUp until we discovered Android handles backspace events weirdly (PORT-2072)

      el.on('input', function () {
        var val = el.val() || ''; // If user is deleting a char and things are already formatted do nothing
        // Checking event.inputType for delete doesn't work cuz android keyboard
        // incorrectly sends "insertCompositionText" for backspace

        if (_lastVal.length === val.length + 1 && /^[A-Z0-9]{3}(-[A-Z0-9]{3})?$/.test(val)) {
          return;
        } // Format the input, update the view, and store to check against on next input


        val = _getFormattedString(val);
        el.val(val);
        _lastVal = val;
        runValidators(el.val());
      });
      ngModel.$parsers.push(function (viewValue) {
        return _getFormattedString(viewValue);
      });
    }
  };
});